export enum PrCycleStatus {
	WIP = "WIP",
	AwaitingReview = "AwaitingReview",
	InReview = "InReview",
	PendingMerge = "PendingMerge",
}
